import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/latin-i.js
t.dynamicSetup("", "latin-i", e({ LI: { italic: {
	192: [
		.969,
		0,
		.743
	],
	193: [
		.952,
		0,
		.743
	],
	194: [
		.923,
		0,
		.743
	],
	195: [
		.867,
		0,
		.743
	],
	196: [
		.845,
		0,
		.743
	],
	197: [
		.892,
		0,
		.743
	],
	198: [
		.683,
		0,
		.883,
		{ ic: .068 }
	],
	199: [
		.705,
		.213,
		.716,
		{ ic: .096 }
	],
	200: [
		.969,
		0,
		.678,
		{ ic: .069 }
	],
	201: [
		.952,
		0,
		.678,
		{ ic: .071 }
	],
	202: [
		.923,
		0,
		.678,
		{ ic: .069 }
	],
	203: [
		.845,
		0,
		.678,
		{ ic: .069 }
	],
	204: [
		.969,
		0,
		.386,
		{ ic: .115 }
	],
	205: [
		.952,
		0,
		.386,
		{ ic: .183 }
	],
	206: [
		.923,
		0,
		.386,
		{ ic: .124 }
	],
	207: [
		.845,
		0,
		.386,
		{ ic: .138 }
	],
	208: [
		.683,
		0,
		.755,
		{ ic: .02 }
	],
	209: [
		.867,
		0,
		.743,
		{ ic: .109 }
	],
	210: [
		.969,
		.022,
		.767,
		{ ic: .021 }
	],
	211: [
		.952,
		.022,
		.767,
		{ ic: .022 }
	],
	212: [
		.923,
		.022,
		.767,
		{ ic: .021 }
	],
	213: [
		.867,
		.022,
		.767,
		{ ic: .021 }
	],
	214: [
		.845,
		.022,
		.767,
		{ ic: .021 }
	],
	216: [
		.743,
		.06,
		.767,
		{ ic: .055 }
	],
	217: [
		.969,
		.022,
		.743,
		{ ic: .109 }
	],
	218: [
		.952,
		.022,
		.743,
		{ ic: .109 }
	],
	219: [
		.923,
		.022,
		.743,
		{ ic: .109 }
	],
	220: [
		.845,
		.022,
		.743,
		{ ic: .109 }
	],
	221: [
		.952,
		0,
		.743,
		{ ic: .131 }
	],
	222: [
		.684,
		.001,
		.627,
		{ ic: .02 }
	],
	223: [
		.705,
		.205,
		.537,
		{ ic: .041 }
	],
	224: [
		.725,
		.011,
		.511,
		{ ic: .014 }
	],
	225: [
		.708,
		.011,
		.511,
		{ ic: .041 }
	],
	226: [
		.679,
		.011,
		.511,
		{ ic: .014 }
	],
	227: [
		.623,
		.011,
		.511,
		{ ic: .031 }
	],
	228: [
		.601,
		.011,
		.511,
		{ ic: .014 }
	],
	229: [
		.709,
		.011,
		.511,
		{ ic: .014 }
	],
	230: [
		.442,
		.011,
		.716,
		{ ic: .003 }
	],
	231: [
		.442,
		.208,
		.46,
		{ ic: .01 }
	],
	232: [
		.725,
		.011,
		.46,
		{ ic: .008 }
	],
	233: [
		.708,
		.011,
		.46,
		{ ic: .122 }
	],
	234: [
		.679,
		.011,
		.46,
		{ ic: .063 }
	],
	235: [
		.601,
		.011,
		.46,
		{ ic: .077 }
	],
	236: [
		.725,
		.011,
		.307,
		{ ic: .024 }
	],
	237: [
		.708,
		.011,
		.307,
		{ ic: .155 }
	],
	238: [
		.679,
		.011,
		.307,
		{ ic: .096 }
	],
	239: [
		.601,
		.011,
		.307,
		{ ic: .11 }
	],
	241: [
		.623,
		.011,
		.562,
		{ ic: .024 }
	],
	242: [
		.725,
		.011,
		.511
	],
	243: [
		.708,
		.011,
		.511,
		{ ic: .091 }
	],
	244: [
		.679,
		.011,
		.511,
		{ ic: .032 }
	],
	245: [
		.623,
		.011,
		.511,
		{ ic: .081 }
	],
	246: [
		.601,
		.011,
		.511,
		{ ic: .046 }
	],
	248: [
		.538,
		.107,
		.511,
		{ ic: .039 }
	],
	249: [
		.725,
		.011,
		.537,
		{ ic: .024 }
	],
	250: [
		.708,
		.011,
		.537,
		{ ic: .025 }
	],
	251: [
		.679,
		.011,
		.537,
		{ ic: .024 }
	],
	252: [
		.601,
		.011,
		.537,
		{ ic: .024 }
	],
	253: [
		.708,
		.205,
		.486,
		{ ic: .096 }
	],
	254: [
		.694,
		.194,
		.511
	],
	255: [
		.601,
		.205,
		.486,
		{ ic: .051 }
	],
	256: [
		.859,
		0,
		.743
	],
	257: [
		.615,
		.011,
		.511,
		{ ic: .03 }
	],
	258: [
		.931,
		0,
		.743
	],
	259: [
		.687,
		.011,
		.511,
		{ ic: .028 }
	],
	260: [
		.716,
		.164,
		.743
	],
	261: [
		.442,
		.179,
		.511,
		{ ic: .014 }
	],
	262: [
		.952,
		.022,
		.716,
		{ ic: .096 }
	],
	263: [
		.708,
		.011,
		.46,
		{ ic: .112 }
	],
	264: [
		.923,
		.022,
		.716,
		{ ic: .096 }
	],
	265: [
		.679,
		.011,
		.46,
		{ ic: .053 }
	],
	266: [
		.897,
		.022,
		.716,
		{ ic: .096 }
	],
	267: [
		.653,
		.011,
		.46,
		{ ic: .01 }
	],
	268: [
		.938,
		.022,
		.716,
		{ ic: .096 }
	],
	269: [
		.694,
		.011,
		.46,
		{ ic: .107 }
	],
	270: [
		.938,
		0,
		.755,
		{ ic: .02 }
	],
	271: [
		.694,
		.011,
		.511,
		{ ic: .295 }
	],
	272: [
		.683,
		0,
		.755,
		{ ic: .02 }
	],
	273: [
		.694,
		.011,
		.511,
		{ ic: .081 }
	],
	274: [
		.859,
		0,
		.678,
		{ ic: .069 }
	],
	275: [
		.615,
		.011,
		.46,
		{ ic: .111 }
	],
	276: [
		.931,
		0,
		.678,
		{ ic: .069 }
	],
	277: [
		.687,
		.011,
		.46,
		{ ic: .109 }
	],
	278: [
		.897,
		0,
		.678,
		{ ic: .069 }
	],
	279: [
		.653,
		.011,
		.46,
		{ ic: .008 }
	],
	280: [
		.68,
		.178,
		.678,
		{ ic: .069 }
	],
	281: [
		.442,
		.186,
		.46,
		{ ic: .008 }
	],
	282: [
		.938,
		0,
		.678,
		{ ic: .069 }
	],
	283: [
		.694,
		.011,
		.46,
		{ ic: .117 }
	],
	284: [
		.923,
		.022,
		.774,
		{ ic: .038 }
	],
	285: [
		.679,
		.205,
		.46,
		{ ic: .053 }
	],
	286: [
		.931,
		.022,
		.774,
		{ ic: .038 }
	],
	287: [
		.687,
		.205,
		.46,
		{ ic: .099 }
	],
	288: [
		.897,
		.022,
		.774,
		{ ic: .038 }
	],
	289: [
		.653,
		.205,
		.46,
		{ ic: .027 }
	],
	290: [
		.705,
		.31,
		.774,
		{ ic: .038 }
	],
	291: [
		.735,
		.205,
		.46,
		{ ic: .027 }
	],
	292: [
		.923,
		0,
		.743,
		{ ic: .109 }
	],
	293: [
		.919,
		.011,
		.511,
		{ ic: .024 }
	],
	294: [
		.683,
		0,
		.743,
		{ ic: .109 }
	],
	295: [
		.694,
		.011,
		.511,
		{ ic: .024 }
	],
	296: [
		.867,
		0,
		.386,
		{ ic: .173 }
	],
	297: [
		.623,
		.011,
		.307,
		{ ic: .145 }
	],
	298: [
		.859,
		0,
		.386,
		{ ic: .172 }
	],
	299: [
		.615,
		.011,
		.307,
		{ ic: .144 }
	],
	300: [
		.931,
		0,
		.386,
		{ ic: .17 }
	],
	301: [
		.687,
		.011,
		.307,
		{ ic: .142 }
	],
	302: [
		.683,
		.175,
		.386,
		{ ic: .115 }
	],
	303: [
		.654,
		.18,
		.307,
		{ ic: .051 }
	],
	304: [
		.897,
		0,
		.386,
		{ ic: .115 }
	],
	306: [
		.683,
		.022,
		.872,
		{ ic: .097 }
	],
	307: [
		.654,
		.205,
		.583,
		{ ic: .06 }
	],
	308: [
		.923,
		.022,
		.525,
		{ ic: .123 }
	],
	309: [
		.679,
		.205,
		.307,
		{ ic: .102 }
	],
	310: [
		.683,
		.283,
		.769,
		{ ic: .09 }
	],
	311: [
		.694,
		.283,
		.46,
		{ ic: .042 }
	],
	312: [
		.43,
		0,
		.531
	],
	313: [
		.952,
		0,
		.627
	],
	314: [
		.948,
		.011,
		.256,
		{ ic: .23 }
	],
	315: [
		.683,
		.283,
		.627
	],
	316: [
		.694,
		.283,
		.256,
		{ ic: .05 }
	],
	317: [
		.696,
		0,
		.627,
		{ ic: .198 }
	],
	318: [
		.694,
		.011,
		.256,
		{ ic: .302 }
	],
	319: [
		.683,
		0,
		.627
	],
	320: [
		.694,
		.011,
		.456
	],
	321: [
		.683,
		0,
		.627
	],
	322: [
		.694,
		.011,
		.319,
		{ ic: .032 }
	],
	323: [
		.952,
		0,
		.743,
		{ ic: .109 }
	],
	324: [
		.708,
		.011,
		.562,
		{ ic: .05 }
	],
	325: [
		.683,
		.283,
		.743,
		{ ic: .109 }
	],
	326: [
		.442,
		.283,
		.562,
		{ ic: .024 }
	],
	327: [
		.938,
		0,
		.743,
		{ ic: .109 }
	],
	328: [
		.694,
		.011,
		.562,
		{ ic: .045 }
	],
	329: [
		.694,
		.011,
		.819,
		{ ic: .024 }
	],
	330: [
		.705,
		.022,
		.743,
		{ ic: .078 }
	],
	331: [
		.442,
		.216,
		.498,
		{ ic: .02 }
	],
	332: [
		.859,
		.022,
		.767,
		{ ic: .021 }
	],
	333: [
		.615,
		.011,
		.511,
		{ ic: .08 }
	],
	334: [
		.931,
		.022,
		.767,
		{ ic: .021 }
	],
	335: [
		.687,
		.011,
		.511,
		{ ic: .078 }
	],
	336: [
		.939,
		.022,
		.767,
		{ ic: .036 }
	],
	337: [
		.695,
		.011,
		.511,
		{ ic: .105 }
	],
	338: [
		.705,
		.022,
		.985,
		{ ic: .068 }
	],
	339: [
		.443,
		.012,
		.716,
		{ ic: .003 }
	],
	340: [
		.952,
		.022,
		.729
	],
	341: [
		.708,
		.011,
		.422,
		{ ic: .11 }
	],
	342: [
		.683,
		.283,
		.729
	],
	343: [
		.442,
		.295,
		.422,
		{ ic: .067 }
	],
	344: [
		.938,
		.022,
		.729
	],
	345: [
		.694,
		.011,
		.422,
		{ ic: .105 }
	],
	346: [
		.952,
		.022,
		.562,
		{ ic: .08 }
	],
	347: [
		.708,
		.011,
		.409,
		{ ic: .123 }
	],
	348: [
		.923,
		.022,
		.562,
		{ ic: .07 }
	],
	349: [
		.679,
		.011,
		.409,
		{ ic: .064 }
	],
	350: [
		.705,
		.217,
		.562,
		{ ic: .07 }
	],
	351: [
		.442,
		.209,
		.409,
		{ ic: .01 }
	],
	352: [
		.938,
		.022,
		.562,
		{ ic: .075 }
	],
	353: [
		.694,
		.011,
		.409,
		{ ic: .118 }
	],
	354: [
		.677,
		.198,
		.716,
		{ ic: .09 }
	],
	355: [
		.626,
		.204,
		.332,
		{ ic: .041 }
	],
	356: [
		.938,
		0,
		.716,
		{ ic: .09 }
	],
	357: [
		.684,
		.011,
		.332,
		{ ic: .296 }
	],
	358: [
		.678,
		0,
		.716,
		{ ic: .09 }
	],
	359: [
		.626,
		.011,
		.332,
		{ ic: .041 }
	],
	360: [
		.867,
		.022,
		.743,
		{ ic: .109 }
	],
	361: [
		.623,
		.011,
		.537,
		{ ic: .024 }
	],
	362: [
		.859,
		.022,
		.743,
		{ ic: .109 }
	],
	363: [
		.615,
		.011,
		.537,
		{ ic: .024 }
	],
	364: [
		.931,
		.022,
		.743,
		{ ic: .109 }
	],
	365: [
		.687,
		.011,
		.537,
		{ ic: .024 }
	],
	366: [
		.953,
		.022,
		.743,
		{ ic: .109 }
	],
	367: [
		.709,
		.011,
		.537,
		{ ic: .024 }
	],
	368: [
		.939,
		.022,
		.743,
		{ ic: .109 }
	],
	369: [
		.695,
		.011,
		.537,
		{ ic: .039 }
	],
	370: [
		.683,
		.195,
		.743,
		{ ic: .109 }
	],
	371: [
		.442,
		.184,
		.537,
		{ ic: .024 }
	],
	372: [
		.923,
		.022,
		.999,
		{ ic: .125 }
	],
	373: [
		.679,
		.011,
		.664,
		{ ic: .033 }
	],
	374: [
		.923,
		0,
		.743,
		{ ic: .131 }
	],
	375: [
		.679,
		.205,
		.486,
		{ ic: .037 }
	],
	376: [
		.845,
		0,
		.743,
		{ ic: .131 }
	],
	377: [
		.952,
		0,
		.613,
		{ ic: .096 }
	],
	378: [
		.708,
		.011,
		.409,
		{ ic: .143 }
	],
	379: [
		.897,
		0,
		.613,
		{ ic: .091 }
	],
	380: [
		.653,
		.011,
		.409,
		{ ic: .055 }
	],
	381: [
		.938,
		0,
		.613,
		{ ic: .091 }
	],
	382: [
		.694,
		.011,
		.409,
		{ ic: .138 }
	],
	383: [
		.705,
		.205,
		.307,
		{ ic: .145 }
	],
	384: [
		.694,
		.011,
		.46
	],
	385: [
		.683,
		0,
		.704,
		{ ic: .03 }
	],
	386: [
		.683,
		0,
		.704,
		{ ic: .026 }
	],
	387: [
		.68,
		.011,
		.46,
		{ ic: .06 }
	],
	388: [
		.689,
		0,
		.704
	],
	389: [
		.692,
		.011,
		.46
	],
	390: [
		.704,
		.023,
		.715,
		{ ic: .022 }
	],
	391: [
		.871,
		.022,
		.846,
		{ ic: .098 }
	],
	392: [
		.656,
		.011,
		.5,
		{ ic: .168 }
	],
	393: [
		.683,
		0,
		.755,
		{ ic: .02 }
	],
	394: [
		.683,
		0,
		.755,
		{ ic: .02 }
	],
	395: [
		.683,
		0,
		.704,
		{ ic: .056 }
	],
	396: [
		.68,
		.011,
		.46,
		{ ic: .08 }
	],
	397: [
		.446,
		.277,
		.472,
		{ ic: .045 }
	],
	398: [
		.68,
		0,
		.678,
		{ ic: .118 }
	],
	399: [
		.705,
		.022,
		.673,
		{ ic: .034 }
	],
	400: [
		.705,
		.022,
		.613,
		{ ic: .078 }
	],
	401: [
		.68,
		.205,
		.652,
		{ ic: .024 }
	],
	402: [
		.705,
		.205,
		.307,
		{ ic: .145 }
	],
	403: [
		.881,
		.022,
		.846,
		{ ic: .098 }
	],
	404: [
		.683,
		.217,
		.751,
		{ ic: .076 }
	],
	405: [
		.694,
		.011,
		.635,
		{ ic: .033 }
	],
	406: [
		.687,
		.011,
		.25,
		{ ic: .039 }
	],
	407: [
		.683,
		0,
		.386,
		{ ic: .115 }
	],
	408: [
		.69,
		0,
		.765,
		{ ic: .095 }
	],
	409: [
		.705,
		.011,
		.513,
		{ ic: .08 }
	],
	410: [
		.694,
		.011,
		.256,
		{ ic: .087 }
	],
	411: [
		.694,
		.01,
		.5,
		{ ic: .01 }
	],
	412: [
		.683,
		.023,
		1.056,
		{ ic: .057 }
	],
	413: [
		.683,
		.205,
		.743,
		{ ic: .109 }
	],
	414: [
		.442,
		.195,
		.562
	],
	415: [
		.705,
		.022,
		.767,
		{ ic: .021 }
	],
	416: [
		.789,
		.022,
		.767,
		{ ic: .06 }
	],
	417: [
		.536,
		.011,
		.511,
		{ ic: .074 }
	],
	418: [
		.706,
		.2,
		.852,
		{ ic: .017 }
	],
	419: [
		.448,
		.199,
		.611
	],
	420: [
		.683,
		0,
		.678,
		{ ic: .052 }
	],
	421: [
		.705,
		.194,
		.511,
		{ ic: .131 }
	],
	422: [
		.683,
		.177,
		.722
	],
	423: [
		.705,
		.022,
		.562,
		{ ic: .047 }
	],
	424: [
		.442,
		.011,
		.409,
		{ ic: .008 }
	],
	425: [
		.683,
		0,
		.716,
		{ ic: .069 }
	],
	426: [
		.705,
		.205,
		.332
	],
	427: [
		.626,
		.203,
		.332,
		{ ic: .041 }
	],
	428: [
		.677,
		0,
		.711,
		{ ic: .09 }
	],
	429: [
		.645,
		.011,
		.332,
		{ ic: .152 }
	],
	430: [
		.678,
		.205,
		.722,
		{ ic: .084 }
	],
	431: [
		.789,
		.022,
		.743,
		{ ic: .131 }
	],
	432: [
		.536,
		.011,
		.537,
		{ ic: .093 }
	],
	433: [
		.705,
		0,
		.716,
		{ ic: .058 }
	],
	434: [
		.697,
		.022,
		.724
	],
	435: [
		.689,
		0,
		.749,
		{ ic: .188 }
	],
	436: [
		.702,
		.205,
		.64,
		{ ic: .156 }
	],
	437: [
		.683,
		.001,
		.613,
		{ ic: .091 }
	],
	438: [
		.442,
		.011,
		.409,
		{ ic: .055 }
	],
	439: [
		.683,
		.022,
		.562,
		{ ic: .1 }
	],
	440: [
		.683,
		.022,
		.562,
		{ ic: .158 }
	],
	441: [
		.432,
		.225,
		.444,
		{ ic: .018 }
	],
	442: [
		.43,
		.205,
		.444,
		{ ic: .022 }
	],
	443: [
		.666,
		.022,
		.511,
		{ ic: .054 }
	],
	444: [
		.665,
		.022,
		.511,
		{ ic: .056 }
	],
	445: [
		.43,
		.014,
		.381
	],
	446: [
		.626,
		.011,
		.409
	],
	447: [
		.46,
		.227,
		.5,
		{ ic: .033 }
	],
	448: [
		.694,
		.194,
		.278
	],
	449: [
		.694,
		.194,
		.444
	],
	450: [
		.695,
		.195,
		.556
	],
	451: [
		.716,
		0,
		.307,
		{ ic: .068 }
	],
	452: [
		.93,
		0,
		1.368,
		{ ic: .091 }
	],
	453: [
		.683,
		.011,
		1.164,
		{ ic: .103 }
	],
	454: [
		.694,
		.011,
		.92,
		{ ic: .103 }
	],
	455: [
		.683,
		.022,
		1.152,
		{ ic: .097 }
	],
	456: [
		.683,
		.205,
		.934,
		{ ic: .05 }
	],
	457: [
		.694,
		.205,
		.562,
		{ ic: .05 }
	],
	458: [
		.683,
		.022,
		1.268,
		{ ic: .097 }
	],
	459: [
		.683,
		.205,
		1.05,
		{ ic: .05 }
	],
	460: [
		.656,
		.205,
		.869,
		{ ic: .05 }
	],
	461: [
		.938,
		0,
		.743
	],
	462: [
		.694,
		.011,
		.511,
		{ ic: .036 }
	],
	463: [
		.938,
		0,
		.386,
		{ ic: .178 }
	],
	464: [
		.694,
		.011,
		.307,
		{ ic: .15 }
	],
	465: [
		.938,
		.022,
		.767,
		{ ic: .021 }
	],
	466: [
		.694,
		.011,
		.511,
		{ ic: .086 }
	],
	467: [
		.938,
		.022,
		.743,
		{ ic: .109 }
	],
	468: [
		.694,
		.011,
		.537,
		{ ic: .024 }
	],
	469: [
		.935,
		.022,
		.743,
		{ ic: .109 }
	],
	470: [
		.727,
		.011,
		.537,
		{ ic: .036 }
	],
	471: [
		1.066,
		.022,
		.743,
		{ ic: .109 }
	],
	472: [
		.82,
		.011,
		.537,
		{ ic: .047 }
	],
	473: [
		1.052,
		.022,
		.743,
		{ ic: .109 }
	],
	474: [
		.806,
		.011,
		.537,
		{ ic: .042 }
	],
	475: [
		1.083,
		.022,
		.743,
		{ ic: .109 }
	],
	476: [
		.837,
		.011,
		.537,
		{ ic: .024 }
	],
	477: [
		.442,
		.011,
		.46,
		{ ic: .039 }
	],
	478: [
		.935,
		0,
		.743,
		{ ic: .011 }
	],
	479: [
		.825,
		.011,
		.511,
		{ ic: .06 }
	],
	480: [
		.987,
		0,
		.743,
		{ ic: .015 }
	],
	481: [
		.743,
		.011,
		.511,
		{ ic: .056 }
	],
	482: [
		.856,
		0,
		.883,
		{ ic: .065 }
	],
	483: [
		.591,
		.011,
		.715,
		{ ic: .002 }
	],
	484: [
		.705,
		.022,
		.774,
		{ ic: .038 }
	],
	485: [
		.442,
		.205,
		.46,
		{ ic: .027 }
	],
	486: [
		.938,
		.022,
		.774,
		{ ic: .038 }
	],
	487: [
		.694,
		.205,
		.46,
		{ ic: .107 }
	],
	488: [
		.938,
		0,
		.769,
		{ ic: .09 }
	],
	489: [
		.934,
		.011,
		.46,
		{ ic: .042 }
	],
	490: [
		.705,
		.211,
		.767,
		{ ic: .021 }
	],
	491: [
		.442,
		.211,
		.511
	],
	492: [
		.795,
		.211,
		.767,
		{ ic: .021 }
	],
	493: [
		.615,
		.211,
		.511,
		{ ic: .08 }
	],
	494: [
		.94,
		.022,
		.562,
		{ ic: .101 }
	],
	495: [
		.694,
		.205,
		.46,
		{ ic: .087 }
	],
	496: [
		.694,
		.205,
		.307,
		{ ic: .156 }
	],
	497: [
		.683,
		0,
		1.368,
		{ ic: .091 }
	],
	498: [
		.683,
		.011,
		1.164,
		{ ic: .055 }
	],
	499: [
		.694,
		.011,
		.92,
		{ ic: .055 }
	],
	500: [
		.952,
		.022,
		.774,
		{ ic: .038 }
	],
	501: [
		.708,
		.205,
		.46,
		{ ic: .112 }
	],
	502: [
		.683,
		.011,
		.931,
		{ ic: .033 }
	],
	503: [
		.458,
		.229,
		.5,
		{ ic: .045 }
	],
	504: [
		.969,
		0,
		.743,
		{ ic: .109 }
	],
	505: [
		.725,
		.011,
		.562,
		{ ic: .024 }
	],
	506: [
		1.143,
		0,
		.743,
		{ ic: .057 }
	],
	507: [
		.968,
		.011,
		.511,
		{ ic: .103 }
	],
	508: [
		.906,
		0,
		.883,
		{ ic: .068 }
	],
	509: [
		.696,
		.011,
		.716,
		{ ic: .003 }
	],
	510: [
		.906,
		.06,
		.767,
		{ ic: .055 }
	],
	511: [
		.696,
		.107,
		.511,
		{ ic: .039 }
	],
	512: [
		.939,
		0,
		.743
	],
	513: [
		.695,
		.011,
		.511,
		{ ic: .014 }
	],
	514: [
		.929,
		0,
		.743
	],
	515: [
		.685,
		.011,
		.511,
		{ ic: .014 }
	],
	516: [
		.939,
		0,
		.678,
		{ ic: .069 }
	],
	517: [
		.695,
		.011,
		.46,
		{ ic: .023 }
	],
	518: [
		.929,
		0,
		.678,
		{ ic: .069 }
	],
	519: [
		.685,
		.011,
		.46,
		{ ic: .055 }
	],
	520: [
		.939,
		0,
		.386,
		{ ic: .115 }
	],
	521: [
		.695,
		.011,
		.307,
		{ ic: .056 }
	],
	522: [
		.929,
		0,
		.386,
		{ ic: .116 }
	],
	523: [
		.685,
		.011,
		.307,
		{ ic: .088 }
	],
	524: [
		.939,
		.022,
		.767,
		{ ic: .021 }
	],
	525: [
		.695,
		.011,
		.511
	],
	526: [
		.929,
		.022,
		.767,
		{ ic: .021 }
	],
	527: [
		.685,
		.011,
		.511,
		{ ic: .024 }
	],
	528: [
		.939,
		.022,
		.729
	],
	529: [
		.695,
		.011,
		.422,
		{ ic: .067 }
	],
	530: [
		.929,
		.022,
		.729
	],
	531: [
		.685,
		.011,
		.422,
		{ ic: .067 }
	],
	532: [
		.939,
		.022,
		.743,
		{ ic: .109 }
	],
	533: [
		.695,
		.011,
		.537,
		{ ic: .024 }
	],
	534: [
		.929,
		.022,
		.743,
		{ ic: .109 }
	],
	535: [
		.685,
		.011,
		.537,
		{ ic: .024 }
	],
	536: [
		.705,
		.309,
		.562,
		{ ic: .07 }
	],
	537: [
		.442,
		.283,
		.409,
		{ ic: .01 }
	],
	538: [
		.677,
		.283,
		.716,
		{ ic: .09 }
	],
	539: [
		.626,
		.283,
		.332,
		{ ic: .041 }
	],
	540: [
		.721,
		.063,
		.533,
		{ ic: .051 }
	],
	541: [
		.487,
		.225,
		.533
	],
	542: [
		.938,
		0,
		.743,
		{ ic: .109 }
	],
	543: [
		.934,
		.011,
		.511,
		{ ic: .024 }
	],
	544: [
		.71,
		.2,
		.852,
		{ ic: .015 }
	],
	545: [
		.694,
		.135,
		.511,
		{ ic: .049 }
	],
	546: [
		.7,
		.02,
		.552,
		{ ic: .053 }
	],
	547: [
		.593,
		.02,
		.5
	],
	548: [
		.683,
		.167,
		.611,
		{ ic: .093 }
	],
	549: [
		.442,
		.161,
		.409,
		{ ic: .055 }
	],
	550: [
		.897,
		0,
		.743
	],
	551: [
		.653,
		.011,
		.511,
		{ ic: .014 }
	],
	552: [
		.705,
		.202,
		.678,
		{ ic: .013 }
	],
	553: [
		.442,
		.206,
		.46,
		{ ic: .008 }
	],
	554: [
		.935,
		.022,
		.767,
		{ ic: .033 }
	],
	555: [
		.747,
		.011,
		.511,
		{ ic: .11 }
	],
	556: [
		.957,
		.022,
		.767,
		{ ic: .021 }
	],
	557: [
		.761,
		.011,
		.511,
		{ ic: .125 }
	],
	558: [
		.897,
		.022,
		.767,
		{ ic: .021 }
	],
	559: [
		.653,
		.011,
		.511
	],
	560: [
		.987,
		.022,
		.767,
		{ ic: .037 }
	],
	561: [
		.743,
		.011,
		.511,
		{ ic: .106 }
	],
	562: [
		.859,
		0,
		.743,
		{ ic: .131 }
	],
	563: [
		.615,
		.205,
		.486,
		{ ic: .085 }
	],
	564: [
		.694,
		.163,
		.256,
		{ ic: .083 }
	],
	565: [
		.442,
		.156,
		.587,
		{ ic: .013 }
	],
	566: [
		.626,
		.156,
		.332,
		{ ic: .041 }
	],
	568: [
		.694,
		.011,
		.714
	],
	569: [
		.442,
		.194,
		.71
	],
	570: [
		.778,
		.218,
		.743
	],
	571: [
		.778,
		.218,
		.716,
		{ ic: .096 }
	],
	572: [
		.519,
		.087,
		.46,
		{ ic: .01 }
	],
	573: [
		.683,
		0,
		.627
	],
	574: [
		.778,
		.218,
		.716,
		{ ic: .09 }
	],
	575: [
		.442,
		.205,
		.409,
		{ ic: .01 }
	],
	576: [
		.442,
		.205,
		.409,
		{ ic: .055 }
	],
	577: [
		.705,
		0,
		.444,
		{ ic: .022 }
	],
	578: [
		.42,
		0,
		.444
	],
	579: [
		.683,
		0,
		.704,
		{ ic: .03 }
	],
	580: [
		.683,
		.022,
		.743,
		{ ic: .109 }
	],
	581: [
		.704,
		0,
		.743
	],
	582: [
		.778,
		.218,
		.678,
		{ ic: .071 }
	],
	583: [
		.519,
		.087,
		.46,
		{ ic: .008 }
	],
	584: [
		.683,
		.022,
		.525,
		{ ic: .097 }
	],
	585: [
		.654,
		.205,
		.307,
		{ ic: .103 }
	],
	586: [
		.683,
		.205,
		.715
	],
	587: [
		.442,
		.205,
		.517,
		{ ic: .045 }
	],
	588: [
		.683,
		.022,
		.729
	],
	589: [
		.442,
		.011,
		.422,
		{ ic: .067 }
	],
	590: [
		.683,
		0,
		.743,
		{ ic: .131 }
	],
	591: [
		.442,
		.205,
		.486,
		{ ic: .054 }
	],
	7680: [
		.716,
		.222,
		.743
	],
	7681: [
		.442,
		.222,
		.511,
		{ ic: .014 }
	],
	7682: [
		.897,
		0,
		.704,
		{ ic: .03 }
	],
	7683: [
		.893,
		.011,
		.46
	],
	7684: [
		.683,
		.193,
		.704,
		{ ic: .03 }
	],
	7685: [
		.694,
		.193,
		.46
	],
	7686: [
		.683,
		.155,
		.704,
		{ ic: .03 }
	],
	7687: [
		.694,
		.155,
		.46
	],
	7688: [
		.952,
		.213,
		.716,
		{ ic: .096 }
	],
	7689: [
		.708,
		.208,
		.46,
		{ ic: .112 }
	],
	7690: [
		.897,
		0,
		.755,
		{ ic: .02 }
	],
	7691: [
		.893,
		.011,
		.511,
		{ ic: .101 }
	],
	7692: [
		.683,
		.193,
		.755,
		{ ic: .02 }
	],
	7693: [
		.694,
		.193,
		.511,
		{ ic: .049 }
	],
	7694: [
		.683,
		.155,
		.755,
		{ ic: .02 }
	],
	7695: [
		.694,
		.155,
		.511,
		{ ic: .049 }
	],
	7696: [
		.683,
		.203,
		.755,
		{ ic: .02 }
	],
	7697: [
		.694,
		.204,
		.511,
		{ ic: .049 }
	],
	7698: [
		.683,
		.225,
		.755,
		{ ic: .02 }
	],
	7699: [
		.694,
		.225,
		.511,
		{ ic: .049 }
	],
	7704: [
		.68,
		.225,
		.678,
		{ ic: .069 }
	],
	7705: [
		.442,
		.225,
		.46,
		{ ic: .008 }
	],
	7706: [
		.68,
		.19,
		.678,
		{ ic: .069 }
	],
	7707: [
		.442,
		.19,
		.46,
		{ ic: .008 }
	],
	7710: [
		.897,
		0,
		.653,
		{ ic: .082 }
	],
	7711: [
		.893,
		.205,
		.307,
		{ ic: .155 }
	],
	7712: [
		.859,
		.022,
		.774,
		{ ic: .038 }
	],
	7713: [
		.615,
		.205,
		.46,
		{ ic: .101 }
	],
	7714: [
		.897,
		0,
		.743,
		{ ic: .109 }
	],
	7715: [
		.893,
		.011,
		.511,
		{ ic: .024 }
	],
	7716: [
		.683,
		.193,
		.743,
		{ ic: .109 }
	],
	7717: [
		.694,
		.193,
		.511,
		{ ic: .024 }
	],
	7718: [
		.845,
		0,
		.743,
		{ ic: .109 }
	],
	7719: [
		.841,
		.011,
		.511,
		{ ic: .024 }
	],
	7722: [
		.683,
		.225,
		.743,
		{ ic: .109 }
	],
	7723: [
		.694,
		.225,
		.511,
		{ ic: .024 }
	],
	7724: [
		.683,
		.19,
		.386,
		{ ic: .115 }
	],
	7725: [
		.654,
		.19,
		.307,
		{ ic: .051 }
	],
	7726: [
		1.072,
		0,
		.386,
		{ ic: .207 }
	],
	7727: [
		.838,
		.011,
		.307,
		{ ic: .186 }
	],
	7728: [
		.952,
		0,
		.769,
		{ ic: .09 }
	],
	7729: [
		.948,
		.011,
		.46,
		{ ic: .042 }
	],
	7730: [
		.683,
		.193,
		.769,
		{ ic: .09 }
	],
	7731: [
		.694,
		.193,
		.46,
		{ ic: .042 }
	],
	7732: [
		.683,
		.155,
		.769,
		{ ic: .09 }
	],
	7733: [
		.694,
		.155,
		.46,
		{ ic: .042 }
	],
	7734: [
		.683,
		.193,
		.627
	],
	7735: [
		.694,
		.193,
		.256,
		{ ic: .05 }
	],
	7736: [
		.859,
		.193,
		.627
	],
	7737: [
		.855,
		.193,
		.256,
		{ ic: .219 }
	],
	7738: [
		.683,
		.155,
		.627
	],
	7739: [
		.694,
		.155,
		.256,
		{ ic: .081 }
	],
	7740: [
		.683,
		.225,
		.627
	],
	7741: [
		.694,
		.225,
		.256,
		{ ic: .05 }
	],
	7742: [
		.952,
		0,
		.897,
		{ ic: .105 }
	],
	7743: [
		.708,
		.011,
		.818,
		{ ic: .024 }
	],
	7744: [
		.897,
		0,
		.897,
		{ ic: .105 }
	],
	7745: [
		.653,
		.011,
		.818,
		{ ic: .024 }
	],
	7746: [
		.683,
		.193,
		.897,
		{ ic: .105 }
	],
	7747: [
		.442,
		.193,
		.818,
		{ ic: .024 }
	],
	7748: [
		.897,
		0,
		.743,
		{ ic: .109 }
	],
	7749: [
		.653,
		.011,
		.562,
		{ ic: .024 }
	],
	7750: [
		.683,
		.193,
		.743,
		{ ic: .109 }
	],
	7751: [
		.442,
		.193,
		.562,
		{ ic: .024 }
	],
	7752: [
		.683,
		.155,
		.743,
		{ ic: .109 }
	],
	7753: [
		.442,
		.155,
		.562,
		{ ic: .024 }
	],
	7754: [
		.683,
		.225,
		.743,
		{ ic: .109 }
	],
	7755: [
		.442,
		.225,
		.562,
		{ ic: .024 }
	],
	7764: [
		.952,
		0,
		.678,
		{ ic: .052 }
	],
	7765: [
		.708,
		.194,
		.511,
		{ ic: .071 }
	],
	7766: [
		.897,
		0,
		.678,
		{ ic: .052 }
	],
	7767: [
		.653,
		.194,
		.511
	],
	7768: [
		.897,
		.022,
		.729
	],
	7769: [
		.653,
		.011,
		.422,
		{ ic: .067 }
	],
	7770: [
		.683,
		.193,
		.729
	],
	7771: [
		.442,
		.205,
		.422,
		{ ic: .067 }
	],
	7772: [
		.859,
		.193,
		.729
	],
	7773: [
		.615,
		.205,
		.422,
		{ ic: .099 }
	],
	7774: [
		.683,
		.155,
		.729
	],
	7775: [
		.442,
		.167,
		.422,
		{ ic: .067 }
	],
	7776: [
		.897,
		.022,
		.562,
		{ ic: .07 }
	],
	7777: [
		.653,
		.011,
		.409,
		{ ic: .01 }
	],
	7778: [
		.705,
		.219,
		.562,
		{ ic: .07 }
	],
	7779: [
		.442,
		.193,
		.409,
		{ ic: .01 }
	],
	7784: [
		.897,
		.219,
		.562,
		{ ic: .07 }
	],
	7785: [
		.653,
		.193,
		.409,
		{ ic: .01 }
	],
	7786: [
		.897,
		0,
		.716,
		{ ic: .09 }
	],
	7787: [
		.823,
		.011,
		.332,
		{ ic: .041 }
	],
	7788: [
		.677,
		.193,
		.716,
		{ ic: .09 }
	],
	7789: [
		.626,
		.193,
		.332,
		{ ic: .041 }
	],
	7790: [
		.677,
		.155,
		.716,
		{ ic: .09 }
	],
	7791: [
		.626,
		.155,
		.332,
		{ ic: .041 }
	],
	7792: [
		.677,
		.225,
		.716,
		{ ic: .09 }
	],
	7793: [
		.626,
		.225,
		.332,
		{ ic: .041 }
	],
	7794: [
		.683,
		.171,
		.743,
		{ ic: .109 }
	],
	7795: [
		.442,
		.165,
		.537,
		{ ic: .024 }
	],
	7796: [
		.683,
		.196,
		.743,
		{ ic: .109 }
	],
	7797: [
		.442,
		.19,
		.537,
		{ ic: .024 }
	],
	7798: [
		.683,
		.231,
		.743,
		{ ic: .109 }
	],
	7799: [
		.442,
		.225,
		.537,
		{ ic: .024 }
	],
	7804: [
		.867,
		.022,
		.743,
		{ ic: .125 }
	],
	7805: [
		.623,
		.011,
		.46,
		{ ic: .092 }
	],
	7806: [
		.683,
		.204,
		.743,
		{ ic: .125 }
	],
	7807: [
		.442,
		.193,
		.46,
		{ ic: .033 }
	],
	7808: [
		.969,
		.022,
		.999,
		{ ic: .125 }
	],
	7809: [
		.725,
		.011,
		.664,
		{ ic: .033 }
	],
	7810: [
		.952,
		.022,
		.999,
		{ ic: .125 }
	],
	7811: [
		.708,
		.011,
		.664,
		{ ic: .033 }
	],
	7812: [
		.845,
		.022,
		.999,
		{ ic: .125 }
	],
	7813: [
		.601,
		.011,
		.664,
		{ ic: .033 }
	],
	7814: [
		.897,
		.022,
		.999,
		{ ic: .125 }
	],
	7815: [
		.653,
		.011,
		.664,
		{ ic: .033 }
	],
	7816: [
		.683,
		.193,
		.999,
		{ ic: .125 }
	],
	7817: [
		.442,
		.193,
		.664,
		{ ic: .033 }
	],
	7818: [
		.897,
		0,
		.743,
		{ ic: .082 }
	],
	7819: [
		.653,
		.011,
		.464,
		{ ic: .054 }
	],
	7820: [
		.845,
		0,
		.743,
		{ ic: .082 }
	],
	7821: [
		.601,
		.011,
		.464,
		{ ic: .054 }
	],
	7822: [
		.897,
		0,
		.743,
		{ ic: .131 }
	],
	7823: [
		.653,
		.205,
		.486,
		{ ic: .03 }
	],
	7824: [
		.923,
		0,
		.613,
		{ ic: .091 }
	],
	7825: [
		.679,
		.011,
		.409,
		{ ic: .084 }
	],
	7826: [
		.683,
		.193,
		.613,
		{ ic: .091 }
	],
	7827: [
		.442,
		.193,
		.409,
		{ ic: .055 }
	],
	7828: [
		.683,
		.155,
		.613,
		{ ic: .091 }
	],
	7829: [
		.442,
		.155,
		.409,
		{ ic: .055 }
	],
	7830: [
		.694,
		.155,
		.511,
		{ ic: .024 }
	],
	7831: [
		.771,
		.011,
		.332,
		{ ic: .112 }
	],
	7832: [
		.709,
		.011,
		.664,
		{ ic: .033 }
	],
	7833: [
		.709,
		.205,
		.486,
		{ ic: .03 }
	],
	7835: [
		.92,
		.205,
		.306,
		{ ic: .146 }
	],
	7838: [
		.705,
		.011,
		.618
	],
	7840: [
		.716,
		.193,
		.743
	],
	7841: [
		.442,
		.193,
		.511,
		{ ic: .014 }
	],
	7842: [
		.988,
		0,
		.743
	],
	7843: [
		.744,
		.011,
		.511,
		{ ic: .014 }
	],
	7844: [
		1.182,
		0,
		.743,
		{ ic: .03 }
	],
	7845: [
		.918,
		.011,
		.511,
		{ ic: .081 }
	],
	7846: [
		1.199,
		0,
		.743
	],
	7847: [
		.935,
		.011,
		.511,
		{ ic: .014 }
	],
	7848: [
		1.218,
		0,
		.743
	],
	7849: [
		.954,
		.011,
		.511,
		{ ic: .032 }
	],
	7850: [
		1.097,
		0,
		.743,
		{ ic: .02 }
	],
	7851: [
		.833,
		.011,
		.511,
		{ ic: .071 }
	],
	7852: [
		.923,
		.193,
		.743
	],
	7853: [
		.679,
		.193,
		.511,
		{ ic: .014 }
	],
	7854: [
		1.152,
		0,
		.743,
		{ ic: .03 }
	],
	7855: [
		.938,
		.011,
		.511,
		{ ic: .089 }
	],
	7856: [
		1.169,
		0,
		.743
	],
	7857: [
		.938,
		.011,
		.511,
		{ ic: .028 }
	],
	7858: [
		1.188,
		0,
		.743
	],
	7859: [
		.956,
		.011,
		.511,
		{ ic: .035 }
	],
	7860: [
		1.067,
		0,
		.743,
		{ ic: .02 }
	],
	7861: [
		.848,
		.011,
		.511,
		{ ic: .079 }
	],
	7862: [
		.931,
		.193,
		.743
	],
	7863: [
		.687,
		.193,
		.511,
		{ ic: .028 }
	],
	7864: [
		.68,
		.193,
		.678,
		{ ic: .069 }
	],
	7865: [
		.442,
		.193,
		.46,
		{ ic: .008 }
	],
	7866: [
		.988,
		0,
		.678,
		{ ic: .069 }
	],
	7867: [
		.744,
		.011,
		.46,
		{ ic: .073 }
	],
	7868: [
		.867,
		0,
		.678,
		{ ic: .069 }
	],
	7869: [
		.623,
		.011,
		.46,
		{ ic: .112 }
	],
	7870: [
		1.165,
		0,
		.678,
		{ ic: .104 }
	],
	7871: [
		.918,
		.011,
		.46,
		{ ic: .162 }
	],
	7872: [
		1.182,
		0,
		.678,
		{ ic: .069 }
	],
	7873: [
		.935,
		.011,
		.46,
		{ ic: .063 }
	],
	7874: [
		1.201,
		0,
		.678,
		{ ic: .069 }
	],
	7875: [
		.954,
		.011,
		.46,
		{ ic: .113 }
	],
	7876: [
		1.08,
		0,
		.678,
		{ ic: .094 }
	],
	7877: [
		.833,
		.011,
		.46,
		{ ic: .152 }
	],
	7878: [
		.923,
		.193,
		.678,
		{ ic: .069 }
	],
	7879: [
		.679,
		.193,
		.46,
		{ ic: .063 }
	],
	7880: [
		.988,
		0,
		.386,
		{ ic: .134 }
	],
	7881: [
		.744,
		.011,
		.307,
		{ ic: .106 }
	],
	7882: [
		.683,
		.193,
		.386,
		{ ic: .115 }
	],
	7883: [
		.654,
		.193,
		.307,
		{ ic: .051 }
	],
	7884: [
		.705,
		.213,
		.767,
		{ ic: .021 }
	],
	7885: [
		.442,
		.192,
		.511
	],
	7886: [
		.988,
		.022,
		.767,
		{ ic: .021 }
	],
	7887: [
		.744,
		.011,
		.511,
		{ ic: .042 }
	],
	7888: [
		1.162,
		.022,
		.767,
		{ ic: .056 }
	],
	7889: [
		.912,
		.011,
		.511,
		{ ic: .127 }
	],
	7890: [
		1.179,
		.022,
		.767,
		{ ic: .021 }
	],
	7891: [
		.929,
		.011,
		.511,
		{ ic: .032 }
	],
	7892: [
		1.198,
		.022,
		.767,
		{ ic: .021 }
	],
	7893: [
		.948,
		.011,
		.511,
		{ ic: .078 }
	],
	7894: [
		1.077,
		.022,
		.767,
		{ ic: .046 }
	],
	7895: [
		.827,
		.011,
		.511,
		{ ic: .117 }
	],
	7896: [
		.923,
		.213,
		.767,
		{ ic: .021 }
	],
	7897: [
		.679,
		.192,
		.511,
		{ ic: .022 }
	],
	7898: [
		1.02,
		.022,
		.767,
		{ ic: .06 }
	],
	7899: [
		.718,
		.011,
		.511,
		{ ic: .074 }
	],
	7900: [
		1.037,
		.022,
		.767,
		{ ic: .06 }
	],
	7901: [
		.735,
		.011,
		.511,
		{ ic: .074 }
	],
	7902: [
		1.056,
		.022,
		.767,
		{ ic: .06 }
	],
	7903: [
		.754,
		.011,
		.511,
		{ ic: .074 }
	],
	7904: [
		.935,
		.022,
		.767,
		{ ic: .06 }
	],
	7905: [
		.633,
		.011,
		.511,
		{ ic: .074 }
	],
	7906: [
		.789,
		.213,
		.767,
		{ ic: .06 }
	],
	7907: [
		.536,
		.192,
		.511,
		{ ic: .074 }
	],
	7908: [
		.683,
		.199,
		.743,
		{ ic: .109 }
	],
	7909: [
		.442,
		.193,
		.537,
		{ ic: .024 }
	],
	7910: [
		.988,
		.022,
		.743,
		{ ic: .109 }
	],
	7911: [
		.744,
		.011,
		.537,
		{ ic: .024 }
	],
	7912: [
		1.01,
		.022,
		.743,
		{ ic: .131 }
	],
	7913: [
		.708,
		.011,
		.537,
		{ ic: .093 }
	],
	7914: [
		1.027,
		.022,
		.743,
		{ ic: .131 }
	],
	7915: [
		.725,
		.011,
		.537,
		{ ic: .093 }
	],
	7916: [
		1.046,
		.022,
		.743,
		{ ic: .131 }
	],
	7917: [
		.744,
		.011,
		.537,
		{ ic: .093 }
	],
	7918: [
		.925,
		.022,
		.743,
		{ ic: .131 }
	],
	7919: [
		.623,
		.011,
		.537,
		{ ic: .093 }
	],
	7920: [
		.789,
		.199,
		.743,
		{ ic: .131 }
	],
	7921: [
		.536,
		.193,
		.537,
		{ ic: .093 }
	],
	7922: [
		.969,
		0,
		.743,
		{ ic: .131 }
	],
	7923: [
		.725,
		.205,
		.486,
		{ ic: .03 }
	],
	7924: [
		.683,
		.193,
		.743,
		{ ic: .131 }
	],
	7925: [
		.442,
		.424,
		.486,
		{ ic: .03 }
	],
	7926: [
		.988,
		0,
		.743,
		{ ic: .131 }
	],
	7927: [
		.744,
		.205,
		.486,
		{ ic: .047 }
	],
	7928: [
		.867,
		0,
		.743,
		{ ic: .131 }
	],
	7929: [
		.623,
		.205,
		.486,
		{ ic: .086 }
	]
} } }, "NCM"), {}, ["MJX-NCM-LI"]);
//#endregion
